import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CreateOrderDto, Order, OrderWithGamas } from '../../models/Order';
import { FirebaseService } from '../auth/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient,
              private firebaseService: FirebaseService){}

  /**
   * Creates a new Order
   */
  createOrder(order: CreateOrderDto){
    return this.http.post<OrderWithGamas>(`${environment.URL_API}/api/orders`, order, {headers: this.firebaseService.authHeader})
  }

  /**
   * Updates a Order
   */
  updateOrder(order: Partial<Order>){
    return this.http.patch<OrderWithGamas>(`${environment.URL_API}/api/orders/update`, order, {headers: this.firebaseService.authHeader})
  }

  /**
   * Updates a Order with its Gamas
   */
  updateOrderGamas(order: Partial<OrderWithGamas>){
    return this.http.patch<OrderWithGamas>(`${environment.URL_API}/api/orders/update/gamas`, order, {headers: this.firebaseService.authHeader})
  }

  /**
   * Deletes a Order by its id
   */
  deleteOrderById(id: string){
    return this.http.delete(`${environment.URL_API}/api/orders/${id}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Gets all Orders
   */
  getAllOrders(){
    return this.http.get<OrderWithGamas[]>(`${environment.URL_API}/api/orders`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Gets a Order by its id
   */
  getOrderById(id: string){
    return this.http.get<OrderWithGamas>(`${environment.URL_API}/api/orders/${id}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Get Order by Order Number
   */
  getOrderByOrderNumber(order_number: string){
    return this.http.get<OrderWithGamas>(`${environment.URL_API}/api/orders/order/${order_number}`, {headers: this.firebaseService.authHeader})
  }
}